// Shared color utility to ensure consistent colors between CoverFlow and Grid
export const FALLBACK_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD',
  '#D4A5A5', '#9B59B6', '#3498DB', '#E74C3C', '#2ECC71',
  '#F5D76E', '#3FC380', '#8E44AD', '#3498DB', '#E08283'
];

export const getColorForPosition = (x, y) => {
  const colorIndex = ((x + y) % FALLBACK_COLORS.length + FALLBACK_COLORS.length) % FALLBACK_COLORS.length;
  return FALLBACK_COLORS[colorIndex];
};




